import { Col, Row } from 'antd';
import React, { useState, useEffect, ReactElement, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../../../loading';
import PushSettings from './PushSettings';
import { APNDataType, FCMDataType } from './interface';
import { setAWSCreds } from '../../../../utils/accessToken';
import { getAPNData, getFCMData } from './api';
const PushSettingsContainer = (): ReactElement => {
  const { accountId } =
    useParams<{
      accountId: string;
    }>();
  const [APNData, setAPNData] = useState<APNDataType>();
  const [FCMData, setFCMData] = useState<FCMDataType>();
  const [loadingAPNData, setLoadingAPNData] = useState<boolean>(true);
  const [loadingFCMData, setLoadingFCMData] = useState<boolean>(true);
  const fetchAPNData = useCallback(() => {
    setLoadingAPNData(true);
    setAWSCreds().then(() => {
      getAPNData(accountId).then((res) => {
        setAPNData(res);
        setLoadingAPNData(false);
      });
    });
  }, [accountId]);
  const fetchFCMData = useCallback(() => {
    setLoadingFCMData(true);
    setAWSCreds().then(() => {
      getFCMData(accountId).then((res) => {
        setFCMData(res);
        setLoadingFCMData(false);
      });
    });
  }, [accountId]);
  useEffect(() => {
    fetchAPNData();
    fetchFCMData();
  }, [fetchAPNData, fetchFCMData]);

  if (loadingAPNData || loadingFCMData)
    return (
      <Row justify="center">
        <Col>
          <Loading />
        </Col>
      </Row>
    );

  return <PushSettings APNData={APNData} FCMData={FCMData} />;
};
export default PushSettingsContainer;
